/* eslint-disable no-param-reassign,no-cond-assign,no-return-assign */
/* global document */
import './bootstrap'

import Vue from 'vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import Vuex from 'vuex'

import * as Sentry from '@sentry/browser'

import { Vue as VueIntegration } from '@sentry/integrations'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import VueScrollTo from 'vue-scrollto'

// eslint-disable-next-line import/no-extraneous-dependencies
import vSelect from 'vue-select'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-select/dist/vue-select.css'

Vue.use(VueScrollTo)
Vue.component('v-select', vSelect)
Vue.use('vue-slick-carousel', VueSlickCarousel)
Vue.use(Vuex)

Vue.component('get-a-quote', require('./components/GetAQuote/GetAQuote.vue').default)
Vue.component('block-pallet', require('./components/GetAQuote/BlockPallet.vue').default)
Vue.component('stringer-pallet', require('./components/GetAQuote/StringerPallet.vue').default)
Vue.component('fieldsBlockPallet', require('./components/GetAQuote/fieldsBlockPallet.vue').default)
Vue.component('fieldsStringerPallet', require('./components/GetAQuote/fieldsStringerPallet.vue').default)
Vue.component('fieldsStringerPalletSelect', require('./components/GetAQuote/fieldsStringerPalletSelect.vue').default)
Vue.component('modal-contact-form', require('./components/contact/contactModal.vue').default)
Vue.component('contact-form', require('./components/contact/contact.vue').default)
Vue.component('vacancy-form', require('./components/vacancy/vacancy.vue').default)
Vue.component('fieldsvacancy', require('./components/vacancy/fieldsvacancy.vue').default)

const sentryDSN = document.querySelector('meta[name="sentry-dsn"]')
    .getAttribute('content')

if (sentryDSN) {
    Sentry.init({
        dsn: sentryDSN,
        integrations: [
            new VueIntegration({
                Vue,
                attachProps: true,
                logErrors: true,
            }),
        ],
    })
}

function setObject(name, value, context) {
    const parts = name.split('.')
    const p = parts.pop()
    let i = 0; let
        j
    for (; context && (j = parts[i]); i += 1) {
        context = (j in context ? context[j] : context[j] = {})
    }
    return context && p ? (context[p] = value) : undefined // Object
}

Vue.prototype.$eventPool = new Vue()

// eslint-disable-next-line no-unused-vars
const store = () => new Vuex.Store({
    state: {
        joinModalAtive: false,
        contactModalActive: false,
        submitStatus: null,
        submitStatusModal: null,
        currentForm: {},
        currentFormStatus: '',
        currentFormValidation: {},
        blockPalletActive: false,
        stringerPalletActive: false,
        contactInformationActive: true,
        contactInformation: {},
        blockPallet: {},
        stringerPallet: {},
        contacts: {},
        sectionName: {},
        groupName: '',
        fieldGroupName: '',
    },
    mutations: {
        setFormField(state, payload) {
            console.log('setFormField', state, payload)
            const { currentForm } = state
            setObject(payload.field, payload.value, currentForm)

            // Object.keys(currentForm).forEach((item) => {
            //             //     Object.keys(currentForm[item]).forEach((itemChild) => {
            //             //         if (currentForm[item][itemChild] === '') {
            //             //             // eslint-disable-next-line no-console
            //             //             delete (currentForm[item][itemChild])
            //             //         }
            //             //
            //             //         if (currentForm[item][itemChild] === null) {
            //             //             // eslint-disable-next-line no-console
            //             //             delete (currentForm[item][itemChild])
            //             //         }
            //             //     })
            //             // })
            state.currentForm = currentForm
        },
        formValidation(state, payload) {
            console.log('formValidation', state, payload)
            const { currentFormValidation } = state
            setObject(payload.field, payload.value, currentFormValidation)
            state.currentFormValidation = currentFormValidation
        },
    },
})

// eslint-disable-next-line no-unused-vars
const body = document.querySelector('body')

export default new Vue({
    el: '#app',
    store,
    components: {
        VueSlickCarousel,
    },
    data() {
        return {
            settingsSlider: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: false,
                dots: true,
                arrows: false,
                edgeFriction: 0.35,
                infinite: true,
                autoplay: null,
                adaptiveHeight: true,
                speed: 500,
            },
            settingsSliderMobile: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: false,
                dots: false,
                arrows: false,
                edgeFriction: 0.35,
                centerMode: false,
                infinite: false,
                autoplay: null,
                draggable: false,
                speed: 500,
                touchMove: true,
                variableWidth: true,
            },
            activeIndex: -1,
            activeIndexModal: -1,
            mobileActive: false,
            mobileMenuActive: false,
            noscrollActive: false,
            careersCategoryName: 'all',
            glossaryLetter: 'a',
            glossaryItem: '',
        }
    },
    methods: {
        careersItem(index) {
            if (this.activeIndex === index) {
                this.activeIndex = -1
                this.$store.state.noscrollActive = false
            } else {
                this.activeIndex = index
                this.$store.state.noscrollActive = true
            }
        },
        mobileMenu(index) {
            if (this.activeIndex === index) {
                this.activeIndex = -1
            } else {
                this.activeIndex = index
            }
        },
        closeCareersModal() {
            this.activeIndex = -1
            this.$store.state.noscrollActive = false
        },
        openModal(index) {
            this.activeIndexModal = index
            this.$store.state.noscrollActive = true
        },
        closeModal() {
            this.activeIndexModal = -1
            this.$store.state.noscrollActive = false
        },
        openModaljoin() {
            this.$store.state.joinModalAtive = true
            this.$store.state.noscrollActive = true
        },
        openModalContact() {
            this.$store.state.contactModalActive = true
            this.$store.state.noscrollActive = true
        },
        openMenu() {
            this.mobileMenuActive = !this.mobileMenuActive
        },
        topScroll() {
            VueScrollTo.scrollTo('.header', 300)
        },
        careersCategory(index) {
            this.careersCategoryName = index
        },
        glossary(letter) {
            this.glossaryLetter = letter
            setTimeout(() => {
                const glossary = document.querySelector('.Glossary__WordsList__Titles.active>.Glossary__WordsList__Title')
                if (typeof (glossary) !== 'undefined' && glossary != null) {
                    glossary.click()
                }
            }, 1000)
        },
        glossaryTab(item) {
            this.glossaryItem = item

            if (document.documentElement.clientWidth < 561) {
                VueScrollTo.scrollTo('.anchor', 300)
            }
        },
    },
    mounted() {
        /* glossary page */
        const glossary = document.querySelector('.Glossary__Navigation__Item')
        if (typeof (glossary) !== 'undefined' && glossary != null) {
            glossary.click()
        }
        /* end glossary page */

        this.mobileMenuActive = false

        if (document.documentElement.clientWidth < 769) {
            this.mobileActive = true
        } else {
            this.mobileActive = false
        }
    },
    updated() {
        if (this.$store.state.noscrollActive) {
            body.classList.add('noscroll')
        } else {
            body.classList.remove('noscroll')
        }
    },
})
